import { AcContainer, AcFormCard, AcTypography } from '@components'
import { LABELS } from '@constants'
import { useStore } from '@hooks/use-store'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import styles from './tag-information.module.scss'

export interface ITagInformationTab {
  name?: string
}

export const TagInformationTab = observer(
  (_props: ITagInformationTab) => {
    const { tags } = useStore()
    const tag = tags.single

    if (!tag) return null

    return (
      <AcContainer>
        <AcFormCard title={LABELS.TAG_INFORMATION}>
          <div className={styles['info-grid']}>
            <div className={styles['info-item']}>
              <AcTypography weight="semibold">{LABELS.NAME}</AcTypography>
              <AcTypography>{tag.name}</AcTypography>
            </div>
            <div className={styles['info-item']}>
              <AcTypography weight="semibold">{LABELS.CATEGORY}</AcTypography>
              <AcTypography>{tag.category}</AcTypography>
            </div>
            <div className={styles['info-item']}>
              <AcTypography weight="semibold">{LABELS.CREATED}</AcTypography>
              <AcTypography>
                {dayjs(tag.created_at).format('DD-MM-YYYY HH:mm')}
              </AcTypography>
            </div>
            <div className={styles['info-item']}>
              <AcTypography weight="semibold">
                {LABELS.LAST_UPDATED}
              </AcTypography>
              <AcTypography>
                {dayjs(tag.updated_at).format('DD-MM-YYYY HH:mm')}
              </AcTypography>
            </div>
          </div>
        </AcFormCard>
      </AcContainer>
    )
  }
)
